import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Select, Icon } from 'antd';
import QRCode from 'qrcode.react';
import { getState as getGlobalState } from '../../reducers/Global/GlobalReducer';
import { closeTimePublishBuyModalAction } from '../../actions/GlobalAction';
import Modal from '../Modal';
import Message from '../Message';
import ajax from '../../utils/ajax';
import styles from './TimePublishBuyModal.scss';

const { Option } = Select;

@connect(
  (state) => {
    const globalState = getGlobalState(state);
    const modalState = globalState.get('timePublishBuyModal');
    return {
      visible: modalState.get('visible'),
      modalData: modalState.get('data'),
    };
  },
  dispatch => ({
    $closeModal: () => dispatch(closeTimePublishBuyModalAction()),
  }),
)
export default class TimePublishBuyModal extends PureComponent {
  state = {
    channel: 'alipay',
    paying: false,
    codeUrl: '',
  };

  reset = () => {
    this.clearTimer();
    this.setState({
      channel: 'alipay',
      paying: false,
      codeUrl: '',
    });
  };

  clearTimer = () => {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  };

  handleChannelChange = (v) => {
    this.clearTimer();
    this.setState({
      channel: v,
      codeUrl: '',
    });
  };

  checkPayStatus = (guid) => {
    const polling = () => {
      // 如果modal关闭了，则不再进行轮询
      const { visible } = this.props;
      if (!visible) {
        return;
      }
      ajax.getOrderStatus(guid).then(({ data }) => {
        // 支付成功
        if (data.paid_state === 'paid') {
          this.clearTimer();
          // 提示显示5秒
          Message.success('你已经获得1次定时发文功能，文章定时发布成功后会消耗1次权益', { duration: 5000 });
          this.props.$closeModal();
        }
      });
      this.timer = setTimeout(polling, 2000);
    };
    polling();
  };

  handlePay = async () => {
    const { channel, paying } = this.state;
    if (paying) {
      return;
    }
    this.clearTimer();
    this.setState({
      paying: true,
    });
    const isWeChatPay = channel === 'wx_pub_qr';
    let newWindow;
    if (!isWeChatPay) {
      newWindow = window.open();
    }
    try {
      const { data: { guid } } = await ajax.getTimePublishGuid();
      const { data: orderData } = await ajax.payOrder(guid, channel);
      // 微信支付
      if (isWeChatPay) {
        this.setState({
          codeUrl: orderData.wx_pub_qr,
        });
      } else {
        // 支付宝支付，需要提前打开新窗口，否则会被拦截
        newWindow.location = orderData.payment_url;
      }
      this.setState({
        paying: false,
      });
      newWindow = null;
      this.checkPayStatus(guid);
    } catch (e) {
      this.setState({
        paying: false,
      });
      if (!isWeChatPay && newWindow) {
        newWindow.close();
        newWindow = null;
      }
    }
  };

  handleCancel = () => {
    const { $closeModal } = this.props;
    $closeModal();
  };

  getModalContent = () => {
    const { modalData } = this.props;
    const { channel, codeUrl } = this.state;
    const amount = modalData.get('amount', 0);
    return (
      <React.Fragment>
        <div className={styles.title}>开通定时发文</div>
        <div className={styles.item}>
          <div className={styles['item-name']}>单次开通</div>
          <div className={styles['item-value']}>￥{(amount / 100).toFixed(2)}</div>
        </div>
        <div className={styles.item}>
          <div className={styles['item-name']}>支付方式</div>
          <Select value={channel} onChange={this.handleChannelChange}>
            <Option value="alipay">支付宝支付</Option>
            <Option value="wx_pub_qr">微信支付</Option>
          </Select>
        </div>
        {codeUrl && (
          <div>
            <QRCode value={codeUrl} size={200} level={'M'} includeMargin/>
          </div>
        )}
        <div className={styles['member-tips']}>
          <div>
            <div className={styles.tip}>你可以选择开通简书会员，</div>
            <div className={styles.tip}>开通后，在会员有效期内，可以免费试用该功能</div>
          </div>
          <a className={styles.buy} href="/mobile/club" target="_blank">开通会员 <Icon type="right"/></a>
        </div>
        <div className={styles.btn} onClick={this.handlePay} aria-label={'立即支付'}>立即支付</div>
        <div className={styles['buy-tip']}><Icon type="info-circle"/> 该商品为虚拟商品，支付后不支持退款哦</div>
      </React.Fragment>
    );
  };

  render() {
    const { visible } = this.props;

    return (
      <Modal
        width={480}
        bodyClass={styles.body}
        visible={visible}
        maskClosable
        isMiddle
        tips={false}
        showFooter={false}
        onCancel={this.handleCancel}
        afterClose={this.reset}
      >
        {this.getModalContent()}
      </Modal>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/TimePublishBuyModal/TimePublishBuyModal.js